import { render, staticRenderFns } from "./TemplateGroupAnalytics.vue?vue&type=template&id=4578d20f&scoped=true"
import script from "./TemplateGroupAnalytics.vue?vue&type=script&lang=js"
export * from "./TemplateGroupAnalytics.vue?vue&type=script&lang=js"
import style0 from "./TemplateGroupAnalytics.vue?vue&type=style&index=0&id=4578d20f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4578d20f",
  null
  
)

export default component.exports